import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import ParcelPreviewPdf from "../../components/ParcelPreviewPdf";

const PrintParcelAddress = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [finalAddressList, setFinalAddressList] = useState(
    state?.finalAddressList
  );
  const [bigParcel, setBigParcel] = useState([]);
  const [smallParcel, setSmallParcel] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedSize, setIsCheckedSize] = useState(false);
  const [groupedByStreetData, setGroupedByStreetData] = useState({});
  const [isPrintSelect, setIsPrintSelect] = useState(false)

  const separateAddress = (addressList) => {
    setFinalAddressList(addressList);
    setBigParcel(addressList.filter((el) => el.isBig));
    setSmallParcel(addressList.filter((el) => !el.isBig));
  };

  const groupedByStreet = () => {
    const grouped = finalAddressList.reduce((acc, curr) => {
      const key = curr.streetName;
      if (!acc[key]) acc[key] = [];
      acc[key].push(curr);
      return acc;
    }, {});
    setGroupedByStreetData(grouped);
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    if (checked) {
      setIsCheckedSize(false); // disable size grouping
      groupedByStreet();
    } else {
      setGroupedByStreetData({});
    }
  };

  const handleSizeCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsCheckedSize(checked);
    if (checked) {
      setIsChecked(false); // disable street grouping
      separateAddress(finalAddressList);
    } else {
      setBigParcel([]);
      setSmallParcel([]);
    }
  };

  return (
    <>
    {isPrintSelect ? <ParcelPreviewPdf addressData={finalAddressList} groupBy={isCheckedSize ? "size" : isChecked ? "street" :"none"} setIsPrintSelect={setIsPrintSelect}/>
    :<Layout>
      <div className="d-flex justify-content-end w-100 px-5 gap-3">
        <div className="d-flex gap-1">
          <input
            type="checkbox"
            checked={isCheckedSize}
            onChange={handleSizeCheckboxChange}
          />
          <label className="px-2">Group by Size</label>
        </div>
        <div className="d-flex gap-1">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <label className="px-2">Group by street</label>
        </div>
      </div>
      <div>
        {isChecked ? (
          // Grouped by Street
          Object.entries(groupedByStreetData).map(
            ([street, addresses], idx) => (
              <div key={street}>
                <h5 className="mt-4">{`Street: ${street}`}</h5>
                <Table striped bordered hover className="table-sm mt-2">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Address</th>
                      <th>Street</th>
                      <th>Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addresses.map((item, index) => (
                      <tr key={index}>
                        <td>{item.s_number}</td>
                        <td>{item.address}</td>
                        <td>{item.streetName}</td>
                        <td>{item.isBig ? "Big" : "Small"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )
          )
        ) : isCheckedSize ? (
          // Grouped by Size
          <>
            <h5>Big Parcel</h5>
            <Table striped bordered hover className="table-sm mt-2">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Address</th>
                  <th>Street</th>
                  <th>Size</th>
                </tr>
              </thead>
              <tbody>
                {bigParcel?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.s_number}</td>
                    <td>{item.address}</td>
                    <td>{item.streetName}</td>
                    <td>Big</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <h5>Small Parcel</h5>
            <Table striped bordered hover className="table-sm mt-2">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Address</th>
                  <th>Street</th>
                  <th>Size</th>
                </tr>
              </thead>
              <tbody>
                {smallParcel?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.s_number}</td>
                    <td>{item.address}</td>
                    <td>{item.streetName}</td>
                    <td>Small</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          // No grouping
          <>
            <h5>Parcel</h5>
            <Table striped bordered hover className="table-sm mt-2">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Address</th>
                  <th>Street</th>
                  <th>Size</th>
                </tr>
              </thead>
              <tbody>
                {finalAddressList?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.s_number}</td>
                    <td>{item.address}</td>
                    <td>{item.streetName}</td>
                    <td>{item.isBig ? "Big" : "Small"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </div>

      <div className="d-flex justify-content-center gap-3">
        <Button
          variant="dark"
          className="mb-3 mt-2"
          onClick={() => {
            navigate("/parcelSorting");
          }}
        >
          Go Back
        </Button>
        <Button
          variant="success"
          className="mb-3 mt-2"
          onClick={() => setIsPrintSelect(true)}
        >
          {"Generating PDF"}
        </Button>
      </div>
    </Layout>}
    </>
  );
};

export default PrintParcelAddress;
